module.exports = __webpack_public_path__ + "static/img/1079_small.e04659e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1079_small.png
// module id = KHLb
// module chunks = 1